import React from 'react'
import PropTypes from 'prop-types'
import Turbolinks from 'turbolinks'
import { helpers, urlHelpers } from '../../helpers'

/**
 * Displays a Top 10 product card.
 */
class TopTenProductCard extends React.Component {
  constructor(props) {
    super(props)

    this.getProductLink = this.getProductLink.bind(this)
    this.onClickHandler = this.onClickHandler.bind(this)
  }

  /**
   * Returns the link to the product. Returns the empty string if the product
   * doesn't have a slug.
   *
   * @returns {string}
   */
  getProductLink() {
    if (!this.props.product.slug) {
      return ''
    }
    const ref = this.props.listName
      ? `${this.props.listName}-${this.props.position}`
      : `top-ten-${this.props.position}`

    return urlHelpers.addRef(`/p/${this.props.product.slug}`, ref)
  }

  /**
   * On click event handler for when a user clicks the prooduct card. Tracks
   * the product as having been clicked and then takes the user to the product's
   * destination.
   */
  onClickHandler(e) {
    e.preventDefault()
    let price = null

    let sku = null

    // Parse the price of the variant.
    if (this.props.product.variant && this.props.product.variant.price) {
      price = this.props.product.variant.price
    }

    // Parse the sku of the variant.
    if (this.props.product.variant && this.props.product.variant.sku) {
      sku = this.props.product.variant.sku
    } else {
      sku = this.props.product.sku || null
    }
    $.track(
      'product click',
      {
        id: sku,
        name: this.props.product.name,
        brand: helpers.formatProducers(this.props.product.producers),
        category: this.props.product.variant
          ? this.props.product.variant.oracleDepartmentName
          : null,
        variant: this.props.product.variant
          ? this.props.product.variant.optionsTextAnalytics
          : null,
        position: this.props.position,
        price,
      },
      this.props.listName,
      () => {
        Turbolinks.visit(this.getProductLink())
      },
    )
  }

  render() {
    // For the image use either the override image or the default display image.
    let image = {}

    if (this.props.product.image) {
      image = this.props.product.image
    } else if (this.props.product.displayImageUrl) {
      image = {
        url: this.props.product.displayImageUrl,
      }
    }

    return (
      <a
        href={this.getProductLink()}
        aria-label={this.props.product.name}
        className={`top-ten-product-card can-override-after-background ${
          this.props.loading ? 'is-placeholder' : 'is-loaded'
        }`}
        data-position={this.props.position}
        onClick={this.onClickHandler}
      >
        <figure>
          {this.props.loading ? (
            false
          ) : (
            <img
              data-original={image.url || ''}
              data-fallback-text={this.props.product.name || ''}
              data-position={this.props.position}
              alt={image.alt || this.props.product.name || ''}
              className="is-lazy fade-in has-drop-shadow"
            />
          )}
        </figure>
      </a>
    )
  }
}

TopTenProductCard.defaultProps = {
  product: {},
  position: 0,
  listName: '',
  loading: false,
}

TopTenProductCard.propTypes = {
  product: PropTypes.object,
  position: PropTypes.number,
  listName: PropTypes.string,
  loading: PropTypes.bool,
}

export default TopTenProductCard
